// @flow
/* eslint-disable import/prefer-default-export */
export { default } from './EditableText';
